/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LOGO_MTN from "../../assets/images/momo.png";
import QR_IMAGE from "../../assets/images/qr-code.png";
import APPROUVER from "../../assets/images/approuver.png";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {
  paiementViaQR,
  verificationPaiementViaQR,
} from "../../services/paiement/PaiementRequest";
import { getListeEtablissement } from "../../services/etablissement/etablissementRequest";
import { getListeServicePagination } from "../../services/services-momo/ServiceMomoRequest";
import { Audio, ThreeDots } from "react-loader-spinner";
import { MultiSelect } from "react-multi-select-component";
import { LocalConvenienceStoreOutlined } from "@mui/icons-material";

const languageOption = {
  allItemsAreSelected: "Tous les items sont selectionnées.",
  clearSearch: "Vider la recherche",
  clearSelected: "Vider la selection",
  noOptions: "Pas d'options",
  search: "Rechercher",
  selectAll: "Tout choisir",
  selectAllFiltered: "Select All (Filtered)",
  selectSomeItems: "Selectionner...",
  create: "Créer",
};

const CliniquePaiement = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("PAIEMENT");
  const [montant, setMontant] = useState("");
  const [numero, setNumero] = useState("");
  const [nomCompletClient, setNomCompletClient] = useState("");
  const [referenceFacture, setReferenceFacture] = useState("");
  const [displayContenu, setDisplayContenu] = useState(false);
  const [erreurNumero, setErreurNumero] = useState("");

  // const [codeEtablissement, setCodeEtablissement] = useState("");
  // const [listeServiceDisponible, setListeServiceDisponible] = useState([]);
  // const [selectedServices, setSelectedServices] = useState([]);
  // const [pageQuery, setPageQuery] = useState({
  //   page: 0,
  //   size: 7,
  //   nombrePage: 1,
  //   pagePagination: 1,
  // });
  const { code } = useParams();
  const navigate = useNavigate();

  const cleanForm = () => {
    setMontant("");
    setNumero("");
    setReferenceFacture("");
  };

  const paiementByQR = () => {
    setLoading(true);
    console.log(numero.length);
    console.log(numero.startsWith("05"));

    const codeEtablissement = code.toString();
    if (numero.length === 10 && numero.startsWith("05")) {
      const data = {
        reference: referenceFacture,
        montant: montant,
        numero: numero,
        nom: nomCompletClient,
      };
      paiementViaQR(data, codeEtablissement)
        .then((res) => {
          if (res.data.donnee.titre === "ATTENTE_DE_VALIDATION") {
            pollForPaymentStatus(res.data.donnee.reference, 0);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Échec du paiement :", err);
        });
    } else {
      setLoading(false);
      setPage("PAIEMENT");
      setErreurNumero(
        "Le numéro de transaction doit commencer par 05 et être de 10 chiffres"
      );
    }
  };

  console.log(erreurNumero);

  // Vérifier le statut du paiement
  const pollForPaymentStatus = async (reference, heureDebut) => {
    const minutesMax = 2.5; // Définir la durée maximale en minutes

    if (heureDebut && new Date() - heureDebut > minutesMax * 60 * 1000) {
      // Si la durée spécifiée est écoulée, définissez la page sur "ECHEC"
      setLoading(false);
      setPage("ECHEC");
      console.log("Durée maximale atteinte. Définition de la page sur ECHEC.");
      return;
    }

    let essai = 0;
    console.log("Nouvelle tentative N°", essai);

    try {
      const res = await verificationPaiementViaQR(reference);

      if (res.data.donnee.titre === "ATTENTE_DE_VALIDATION") {
        setTimeout(() => {
          pollForPaymentStatus(reference, heureDebut || new Date());
        }, 5000);
        console.log("En attente");
      } else if (
        res.data.donnee.titre === "ECHEC" ||
        res.data.donnee.titre === "PAIEMENT_INTROUVABLE"
      ) {
        setLoading(false);
        setPage("ECHEC");
        console.log(res);
        console.log("Échec");
      } else {
        setLoading(false);
        setPage("SUCCES");
        console.log("Succès");
      }
    } catch (err) {
      setLoading(false);
      setPage("ECHEC");
      console.error("Échec de la vérification du paiement :", err);
    }
  };

  useEffect(() => {
    if (code) {
      setDisplayContenu(true);
    } else {
      setDisplayContenu(false);
    }
  }, [code]);

  return (
    <>
      {displayContenu ? (
        <div className="flex flex-col w-full h-[100vh] gap-2 bg-[#29668b] overflow-y-auto">
          <div className="flex items-center justify-center mt-[3rem] gap-x-2  cursor-pointer">
            <QrCodeScannerIcon fontSize="large" />
            <span className="text-[20px] text-white font-bold leading-6">
              Paiement via QR clinique
            </span>
          </div>
          <div className="md:w-[60%] lg:w-[60%] w-[90%] mx-auto mt-[1rem] justify-center bg-slate-50 mb-10 flex lg:flex-row md:flex-row flex-col border-[2px] rounded-lg">
            <div className="flex flex-col md:w-[55%] lg:w-[55%] w-[90%] mx-auto ml-4 my-4 gap-4">
              <div className="flex flex-row  justify-center items-center gap-x-4">
                <img src={LOGO_MTN} alt="" width="10%" />
                <span className="text-[20px] text-black font-bold leading-6">
                  Momo
                </span>
              </div>
              <div className="flex flex-col gap-4 w-[80%] mx-auto">
                {!loading && page === "PAIEMENT" ? (
                  <>
                    <label className="form-control w-full">
                      <div className="label">
                        <span className="label-text">Référence de facture</span>
                      </div>
                      <input
                        type="text"
                        value={referenceFacture}
                        onChange={(e) => setReferenceFacture(e.target.value)}
                        placeholder="Référence de facture"
                        className="input input-bordered w-full"
                      />
                    </label>
                    <label className="form-control w-full">
                      <div className="label">
                        <span className="label-text">
                          Nom complet du client
                        </span>
                      </div>
                      <input
                        type="text"
                        value={nomCompletClient}
                        onChange={(e) => setNomCompletClient(e.target.value)}
                        placeholder="Nom & prénoms"
                        className="input input-bordered w-full"
                      />
                    </label>
                    <label className="form-control w-full">
                      <div className="label">
                        <span className="label-text">
                          Numéro de transaction du client
                        </span>
                      </div>
                      <input
                        type="text"
                        value={numero}
                        onChange={(e) => setNumero(e.target.value)}
                        placeholder="05********"
                        className="input input-bordered w-full"
                      />
                    </label>

                    <label className="form-control w-full">
                      <div className="label">
                        <span className="label-text">Montant</span>
                      </div>
                      <input
                        type="text"
                        value={montant}
                        onChange={(e) => setMontant(e.target.value)}
                        // placeholder="10000"
                        className="input input-bordered w-full"
                      />
                    </label>
                    <button
                      onClick={paiementByQR}
                      className="py-4 px-2 font-semibold bg-[#ffcb05] rounded-lg"
                    >
                      Valider le paiement
                    </button>
                    {erreurNumero ? (
                      <div className="text-red-600 text-center">
                        {erreurNumero}
                      </div>
                    ) : null}
                  </>
                ) : !loading && page === "SUCCES" ? (
                  <div className="flex flex-col border-[2px] rounded-lg py-6">
                    <div className="flex flex-col items-center justify-center gap-6">
                      <img
                        src={APPROUVER}
                        className="w-[100px]"
                        alt="image-logo-approuver"
                      />
                      <h2>Paiement validé</h2>
                      <button
                        onClick={() => {
                          setPage("PAIEMENT");
                          cleanForm();
                        }}
                        className="py-2 px-2 font-semibold bg-[#ffcb05] rounded-lg"
                      >
                        Retour
                      </button>
                    </div>
                  </div>
                ) : !loading &&
                  (page === "ECHEC" || page === "PAIEMENT_INTROUVABLE") ? (
                  <div className="flex flex-col border-[2px] rounded-lg py-6">
                    <div className="flex flex-col items-center justify-center gap-6">
                      <h2>Paiement à échoué</h2>
                      <button
                        onClick={() => {
                          setPage("PAIEMENT");
                          cleanForm();
                        }}
                        className="py-2 px-2 font-semibold bg-[#ffcb05] rounded-lg"
                      >
                        Retour
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center gap-6">
                    <ThreeDots
                      height="80"
                      width="80"
                      radius="9"
                      color="#29668b"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={loading}
                    />
                    <h2>Tapez *133# pour valider</h2>
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-center items-center    ml-4 my-4 gap-4">
              <img
                src={QR_IMAGE}
                className="md:w-[80%] lg:w-[80%] w-[50%] mr-4"
                alt=""
              />
            </div>
          </div>
        </div>
      ) : (
        navigate("*")
      )}
    </>
  );
};

export default CliniquePaiement;
